import { jsPDF } from "jspdf";

function loadCertificateImage(certificateURL) {
  return new Promise((resolve, reject) => {
    if (!certificateURL) {
      reject(new Error("certificateURL requerido"));
      return;
    }
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error("No se pudo cargar la imagen del certificado"));
    image.src = certificateURL;
  });
}

export async function downloadCertificatePdf({ certificateURL, userName, diplomadoTitle, folio }) {
  const image = await loadCertificateImage(certificateURL);
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "in",
    format: [16, 12],
  });
  doc.addImage(image, "JPEG", 0.5, 0.5, 15, 11);
  doc.setFontSize(28);
  doc.text(userName, 8.8, 6.4, "center");
  doc.text(`Folio: ${folio}`, 14.5, 9.64, "center");
  doc.save(`certificado-${diplomadoTitle}.pdf`);
}
